const CONTACT_FORM = 'https://2puiq.share.hsforms.com/21DbkxGDSR7SABGQUkbrd-w'

/**
 * The HubSpot form behind every "Contact us" in the app. It was inlined in the sidebar; the upgrade
 * pages need the same one, and a sales form that exists at two spellings is a form that gets updated
 * at one of them.
 */
export const contactUsUrl = ({ email, scopeName }: { email?: string; scopeName?: string }): string => {
  const params = new URLSearchParams()
  if (email) {
    params.set('email', email)
  }
  if (scopeName) {
    params.set('name', scopeName)
  }
  const query = params.toString()
  return query ? `${CONTACT_FORM}?${query}` : CONTACT_FORM
}
